import { AutoComplete, AutoCompleteProps } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { locateItemVertically } from '../functions';
import { ComponentsDispatch, RootState } from '../store';
import { setterGantItems } from '../store/slices/gantItemsSlice';
import { setterGantScroll } from '../store/slices/gantScrollSlice';
import { setterGant } from '../store/slices/gantSlice';
import { ItemType, MappingItemIdHideCollapse, MappingItemIdIndexType } from '../types';

const GantSearch = () => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const mappingItemIdHideCollapse = useSelector<RootState, MappingItemIdHideCollapse>(
        (state) => state.gant.mappingItemIdHideCollapse,
    );
    const availableHeight = useSelector<RootState, number>((state) => state.calendar.availableHeight);

    const [options, setOptions] = useState<AutoCompleteProps['options']>([]);
    const [value, setValue] = useState<string>();

    const onSelect = (data: string) => {
        console.log('onSelect', data);
        // setValue(undefined);
        const newCurrentItem = { ...itemsList[mappingItemIdIndex[data]] };
        setValue(newCurrentItem.name);

        const { newScrollY, newItemsList, newMappingItemIdHideCollapse } = locateItemVertically(
            newCurrentItem,
            itemsList,
            mappingItemIdIndex,
            mappingItemIdHideCollapse,
            availableHeight,
        );
        dispatch(setterGantItems({ isItemEdit: true, currentGantItem: newCurrentItem, ...newItemsList }));
        dispatch(
            setterGant({
                mappingItemIdHideCollapse: newMappingItemIdHideCollapse,
            }),
        );
        dispatch(
            setterGantScroll({
                currentScrollY: newScrollY,
            }),
        );
    };

    const onSearch = (text: string) => {
        setValue(text);
        let newOptions: { label: string; value: string }[] = [];

        if (text) {
            newOptions = itemsList
                .filter((item: ItemType) => item.name.toLowerCase().includes(text.toLowerCase()))
                .map((item: ItemType) => ({
                    label: item.name,
                    value: item.id,
                }));
        }

        setOptions(newOptions);
    };

    return (
        <AutoComplete
            options={options}
            value={value}
            style={{ width: '100%' }}
            onSelect={onSelect}
            onSearch={onSearch}
            placeholder="search"
        />
    );
};

export default GantSearch;
